import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-115d69cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-3 fadeinleft animation-duration-200"
}
const _hoisted_2 = { class: "text-base" }
const _hoisted_3 = { class: "flex align-items-baseline mb-2" }
const _hoisted_4 = { class: "text-4xl mr-1" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "flex justify-content-end" }
const _hoisted_8 = { key: 1 }

import { computed } from "vue";
import { CanvasResponse, TriggerDirection } from "@evolutivelabs/quokka-common";
import Card from "primevue/card";
import ProgressBar from "primevue/progressbar";
import Chart from "primevue/chart";

enum DisplayType {
  None,
  Single,
  Multiple,
}

interface ProgressItem {
  rawValue: number | null;
  percentage: number | null;
  name: string;
  goalTriggerValue: number;
}

interface ChartDataset {
  backgroundColor: string;
  data: number[];
}
interface ChartData {
  labels: string[];
  datasets: ChartDataset[];
}


export default /*#__PURE__*/_defineComponent({
  props: {
    isDeletable: { type: Boolean },
    canvasItem: null
  },
  emits: ["deleteRequest"],
  setup(__props: any, { emit }: { emit: ({
  (e: "deleteRequest", event: Event, id: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isDeletable: boolean;
  canvasItem: CanvasResponse;
}





const onDelete = (event: Event, id: string) => {
  emit("deleteRequest", event, id);
};

const targets = computed(() => [
  ...props.canvasItem.combinedTargets,
  ...props.canvasItem.targets,
]);

const displayType = computed(() => {
  return targets.value.length === 1
    ? DisplayType.Single
    : targets.value.length > 1
    ? DisplayType.Multiple
    : DisplayType.None;
});

const progressItem = computed<ProgressItem | undefined>(() => {
  const target = targets.value[0] as typeof targets.value[number] | undefined;
  if (target !== undefined) {
    const showProgress =
      target.enableGoalTrigger &&
      target.goalTriggerDirection === TriggerDirection.greater &&
      target.goalTriggerValue > 0;
    const progressPercentage =
      ((target.value || 0) / target.goalTriggerValue) * 100;
    const value = showProgress
      ? parseFloat(progressPercentage.toFixed(2))
      : null;

    return {
      name: target.displayName || target.title,
      rawValue: target.value,
      percentage: value,
      goalTriggerValue: target.goalTriggerValue,
    };
  } else {
    return undefined;
  }
});

const chartData = computed<ChartData>(() => {
  const data = targets.value
    .map((t) => ({
      name: t.displayName || t.title,
      value: t.value || 0,
    }))
    .sort((a, b) => b.value - a.value);

  return {
    labels: data.map((d) => d.name),
    datasets: [
      {
        backgroundColor: "#42A5F5",
        data: data.map((d) => d.value),
      },
    ],
  };
});

const chartOptions = {
  indexAxis: "y",
  plugins: {
    legend: {
      display: false,
    },
  },
  maxBarThickness: 24,
  borderRadius: 3,
  scales: {
    y: {
      ticks: {
        font: {
          size: 24,
        },
        autoSkip: false,
      },
    },
  },
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), { class: "shadow-2" }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(props.canvasItem.title), 1)
    ]),
    content: _withCtx(() => [
      (_unref(displayType) === DisplayType.Single && _unref(progressItem) !== undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(progressItem)?.name), 1),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(progressItem)?.rawValue), 1),
              (_unref(progressItem)?.percentage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(`(${_unref(progressItem)?.percentage}%)`), 1))
                : _createCommentVNode("", true)
            ]),
            (_unref(progressItem)?.percentage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_unref(ProgressBar), {
                    value: _unref(progressItem)?.percentage,
                    "show-value": false
                  }, null, 8, ["value"]),
                  _createElementVNode("div", _hoisted_7, " goal: " + _toDisplayString(_unref(progressItem)?.goalTriggerValue), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_unref(displayType) === DisplayType.Multiple)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_unref(Chart), {
              type: "bar",
              data: _unref(chartData),
              options: chartOptions
            }, null, 8, ["data"])
          ]))
        : _createCommentVNode("", true),
      (props.isDeletable)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onDelete($event, props.canvasItem.id)))
          }, " delete "))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})